export default {"src":"/_next/static/media/upload.0533652a.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};